import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems, } from "../../store/actions";

import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { fetchSingleCourse } from "helpers/course_helper";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { createModule, deleteModule, fetchAllModuleOfCourse, updateModule } from "helpers/module_helper";
import { generatePreSignedUrl, generatePresignedUrlForAccess } from "helpers/Content_helper";
import axios from "axios";
import { createLesson, deleteLesson } from "helpers/lesson_helper";
import { v4 as uuidv4 } from 'uuid';


import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { HtmlEditor, Image, Inject, Link, PasteCleanup, QuickToolbar, RichTextEditorComponent, Toolbar } from "@syncfusion/ej2-react-richtexteditor";
import { getQuestionsByAssessment } from "helpers/assessment_helper";
import Assessment from "./Assessment";
import { getStudentProgress, updateProgress } from "helpers/batch_helper";
import { set } from "lodash";
import PDFViewer from "./components/PDFViewer";
import PPTViewer from "./components/PPTViewer";

const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    // { field: 'firstName', headerName: 'First name', width: 130 },
    // { field: 'lastName', headerName: 'Last name', width: 130 },
    {
        field: 'fullName',
        headerName: 'Full name',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    {
        field: 'email',
        headerName: 'Email',
        type: 'text',
        width: 130,
    },
    {
        field: 'number',
        headerName: 'Number',
        type: 'number',
        width: 130,
    },

];

const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35, email: "snow@gmail.com", number: "1234567890" },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42, email: "lannister@gmail.com", number: "1234567890" },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45, email: "lani@gmail.com", number: "1234567890" },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16, email: "stark@gmail.com", number: "1234567890" },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null, email: "targ@gmail.com", number: "1234567890" },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150, email: "meilisandre@gmail.com", number: "1234567890" },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44, email: "clifford@gmail.com", number: "1234567890" },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36, email: "frances@gmail.com", number: "1234567890" },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65, email: "roxie@gmail.com", number: "1234567890" },
];

const columns1 = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },

    {
        field: 'email',
        headerName: 'Email',
        type: 'text',
        width: 130,
    },
    {
        field: 'number',
        headerName: 'Number',
        type: 'number',
        width: 130,
    },

];

const rows1 = [
    { id: 1, name: 'Rahul Sharma', age: 35, email: "snow@gmail.com", number: "1234567890" },
    { id: 2, name: 'Lannister', age: 42, email: "lannister@gmail.com", number: "1234567890" },
];

const paginationModel = { page: 0, pageSize: 5 };
const CourseView = (props) => {

    document.title = "Question Bank | Course View";
    const params = useParams();
    const [id, setId] = useState({});
    const [loader, setLoader] = useState(false);
    const [course, setCourse] = useState(null);
    const [addModuleModal, setAddModuleModal] = useState(false);
    const [editModuleModal, setEditModuleModal] = useState(false);
    const [deleteModuleConfirmModal, setDeleteModuleConfirmModal] = useState(false);
    const [moduleTitle, setModuleTitle] = useState("");
    const [moduleType, setModuleType] = useState("");
    const [moduleOrder, setModuleOrder] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [editModule, setEditModule] = useState(false);
    const [moduleId, setModuleId] = useState("");
    const [modules, setModules] = useState([]);
    const [lessonTitle, setLessonTitle] = useState("");
    const [lessonContentType, setLessonContentType] = useState("");
    const [lessonUrl, setLessonUrl] = useState("");
    const [lessonDuration, setLessonDuration] = useState("");
    const [addLessonModal, setAddLessonModal] = useState(false);
    const [lessonContentFile, setLessonContentFile] = useState("");
    const [lessonContentName, setLessonContentName] = useState("");
    const [selectedModule, setSelectedModule] = useState(null);
    const [lessonOrQuizModal, setLessonOrQuizModal] = useState(false);
    const [editLesson, setEditLesson] = useState(false);
    const [deleteLessonConfirmModal, setDeleteLessonConfirmModal] = useState(false);
    const [createStudentSelectModal, setCreateStudentSelectModal] = useState(false);
    const [createSingleStudentModal, setCreateSingleStudentModal] = useState(false);
    const [createBulkStudentModal, setCreateBulkStudentModal] = useState(false);
    const [lessonId, setLessonId] = useState(false);
    const [updateLessonModal, setUpdateLessonModal] = useState(false);
    const [addTrainerAccessModal, setAddTrainerAccessModal] = useState(false);
    const [selectedTab, setSelectedTab] = useState("modules");
    const [addAssessmentModal, setAddAssessmentModal] = useState(false);
    const [contentLink, setContentLink] = useState(null);
    const [contentType, setContentType] = useState(null);
    const [contentDescription, setContentDescription] = useState(null);
    const [questions, setQuestions] = useState(null);
    const [lessonIndex, setLessonIndex] = useState(null);
    const [currentModuleId, setCurrentModuleId] = useState(null);
    const [studentDetails, setStudentDetails] = useState({
        firstname: '',
        lastname: '',
        email: '',
        mobile: ''
    });

    const breadcrumbItems = [
        { title: "Batch", link: "#" },
        { title: "Course View", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Course View', breadcrumbItems)
    })
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    const fetchCourse = async () => {
        try {
            setLoader(true);
            const data = await fetchSingleCourse(params.id)
            setLoader(false);
            if (data?.success) {
                setCourse(data?.result[0]);
                fetchModules(data?.result[0]);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    const fetchModules = async (c) => {
        try {
            let courseDto = c;
            const data = await fetchAllModuleOfCourse(courseDto);
            if (data?.success) {
                fetchModuleProgress(data?.result);
                setModules(data?.result);
                handleGenerateLink(data?.result?.[0]?.lessons?.[0], 0, data?.result?.[0]);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    useEffect(() => {
        fetchCourse();
    }, [])

    const fetchModuleProgress = async (modules) => {
        try {
            for (let i = 0; i < modules.length; i++) {
                const data = await getStudentProgress(modules[i].id);
                if (data?.success) {
                    modules[i].progress = data?.result[0];
                }
            }
            setModules(modules);

        } catch (error) {

            toast.error(error?.response?.data?.message);
        }
    }

    const handleAddModule = async () => {
        try {
            if (!moduleTitle || !moduleType || !moduleOrder) {
                setSpanDisplay("inline")
            }
            else {



                setLoader(true);
                const data = await createModule({ title: moduleTitle, type: moduleType, moduleOrder, courseDto: course });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setAddModuleModal(false);
                    setModuleTitle("");
                    setModuleType("");
                    setModuleOrder("");
                    fetchModules(course);
                }
                else {
                    toast.error(data?.message);
                }


            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    const handleDeleteModule = async () => {
        try {
            setLoader(true);
            const data = await deleteModule(moduleId);
            if (data?.success) {
                toast.success(data?.message);
                setDeleteModuleConfirmModal(false);
                setModuleId("");
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        } finally {
            setLoader(false);
        }
    }

    const handleUpdateModuleClick = (data) => {
        setEditModuleModal(true);

        setModuleId(data?.id);
        setModuleOrder(data?.moduleOrder);
        setModuleTitle(data?.title);
        setModuleType(data?.type);
    }

    const handleDeleteModuleClick = (id) => {
        setDeleteModuleConfirmModal(true)
        setModuleId(id)
    }

    const handleUpdateModule = async () => {
        try {
            setLoader(true);
            const data = await updateModule({ id: moduleId, title: moduleTitle, type: moduleType, moduleOrder, courseDto: course });
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setEditModuleModal(false);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLessonContentFile(file);
            setLessonContentName(file?.name); // Store the file name
        } else {
            setLessonContentFile(null);
            setLessonContentName('');
        }
    };




    const uploadData = (file, type) => {
        console.log("Entering uploadData");
        return new Promise(async (resolve, reject) => {
            try {
                const name = uuidv4() + '.' + file.name.split('.').pop();
                // Request a pre-signed URL from the backend
                const result = await generatePreSignedUrl({ name, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
                    console.log("Presigned URL: ", url);

                    // Upload the file to S3 using the pre-signed URL
                    await axios.put(url, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });

                    resolve(name);
                } else {
                    reject(result?.message || 'Failed to get pre-signed URL.');
                }
            } catch (error) {
                console.error('Upload error:', error); // Log the error for debugging
                reject('Error uploading the file.');
            }
        });
    };

    const uploadDataForEdit = (file, type, name) => {
        console.log("Entering uploadData");
        return new Promise(async (resolve, reject) => {
            try {
                // Request a pre-signed URL from the backend
                const result = await generatePreSignedUrl({ name, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
                    console.log("Presigned URL: ", url);

                    // Upload the file to S3 using the pre-signed URL
                    await axios.put(url, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });

                    resolve(name);
                } else {
                    reject(result?.message || 'Failed to get pre-signed URL.');
                }
            } catch (error) {
                console.error('Upload error:', error); // Log the error for debugging
                reject('Error uploading the file.');
            }
        });
    };

    function removeSpecificDivs(htmlString) {
        // Parse the HTML string into a new DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Selectors for the divs to remove based on class and id
        const selectorsToRemove = [
            'div.e-rte-content#defaultRTErte-view',
            'div.e-content.e-lib.e-keyboard#defaultRTE_rte-edit-view'
        ];

        // Iterate over selectors and remove the matching elements
        selectorsToRemove.forEach(selector => {
            const elements = doc.querySelectorAll(selector);
            elements.forEach(element => {
                // Instead of removing the element, we replace it with its content
                while (element.firstChild) {
                    element.parentNode.insertBefore(element.firstChild, element);
                }
                element.parentNode.removeChild(element);
            });
        });

        // Serialize the updated DOM back to a string
        // Inner HTML of the body will contain the expected output
        return doc.body.innerHTML;
    }
    const handleAddLesson = async () => {

        const res = rteObjForLessonDescritption.getContent();
        let desc = res.outerHTML;

        desc = removeSpecificDivs(desc);
        let tempElement = document.createElement('div');
        tempElement.innerHTML = res.outerHTML;
        let textCont = tempElement.textContent || tempElement.innerText;

        try {
            if (!lessonTitle || !lessonContentType || !lessonDuration) {
                setSpanDisplay("inline")
            } else {
                setLoader(true);
                let url = "";
                if (lessonContentFile) {

                    url = await uploadData(lessonContentFile, lessonContentType.name);
                }
                const data = await createLesson({ title: lessonTitle, contentType: lessonContentType?.name, duration: lessonDuration, url: url, moduleDto: selectedModule, lessonDescription: desc, lessonDescriptionContent: textCont });

                if (data?.success) {
                    setAddLessonModal(false);
                    setLessonTitle("");
                    setLessonContentFile(null);
                    setLessonContentType(null);
                    setLessonDuration("");
                    setLessonUrl("");
                    toast.success(data?.message);
                    templateForLessonDescription = "";
                    fetchModules(course);
                }
                else {
                    toast.error(data?.message);
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }

    const handleUpdateLessonClick = (data) => {
        console.log(selectedModule)
        setUpdateLessonModal(true);

        setLessonId(data?.id);
        setLessonTitle(data?.title);
        setLessonContentType(lessonContentTypeData.find(item => item.name === data?.contentType));
        setLessonDuration(data?.duration);
    }

    const handleUpdateLesson = async () => {
        try {
            setLoader(true);
            if (lessonContentFile) {
                const url = await uploadDataForEdit(lessonContentFile, lessonContentType.name, lessonUrl);
            }
            const data = await updateLessonModal({ id: lessonId, title: lessonTitle, contentType: lessonContentType?.name, duration: lessonDuration, url: lessonUrl, moduleDto: selectedModule })
            if (data?.success) {
                setUpdateLessonModal(false);
                setLessonTitle("");
                setLessonContentFile(null);
                setLessonContentType(null);
                setLessonDuration("");
                setLessonUrl("");
                toast.success(data?.message);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setLoader(false);
        }
    }

    const lessonContentTypeData = [
        { id: 1, name: "Video" },
        { id: 2, name: "Pdf" },
        { id: 3, name: "PPT" },
    ]
    const handleLessonContentTypeChange = selectedOption => {
        setLessonContentType(selectedOption);
    };

    const handleDeleteLessonClick = (id) => {
        setDeleteLessonConfirmModal(true)
        setLessonId(id)
    }

    const handleDeleteLesson = async () => {
        try {

            setDeleteLessonConfirmModal(false)
            setLoader(true);
            setLoader(false);
            const data = await deleteLesson(lessonId);
            if (data?.success) {
                toast.success(data?.message);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        }
    }


    const handleGenerateLink = async (lesson, i, m) => {
        setLessonIndex(i);
        setCurrentModuleId(m.id);
        setLoader(true);  // Set loading to true when link generation starts

        if (lesson.contentType === "Pdf" || lesson.contentType === "PPT") {
            handleVideoEnd();
        }
        try {
            const response = await generatePresignedUrlForAccess({ name: lesson.url, type: lesson.contentType });
            console.log(response);
            setContentLink(response.presignedUrl);
            setContentType(lesson.contentType);
            setContentDescription(lesson.lessonDescription);
        } catch (error) {
            console.error('Error generating link:', error);
        } finally {
            setLoader(false);  // Set loading to false once the link is generated
        }
    };

    const handleAssessmentClick = async (assessment) => {
        try {
            console.log(assessment);
            setLoader(true);
            setContentType("assessment");

            const data = await getQuestionsByAssessment(assessment);
            if (data?.success) {
                setQuestions(data?.result);
            } else {
                toast.error(data?.message);
            }


        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }


    const handleVideoEnd = async () => {
        try {
            console.log("video end")
            const ids = currentModuleId + "/" + lessonIndex;
            console.log(ids)
            const data = await updateProgress(ids);
            fetchModuleProgress(modules);
        } catch (error) {
            console.log(error);
        }
    };



    // ***** code for rich text editor textarea ****************


    const toolbarSettings = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
            'SourceCode', '|', 'Undo', 'Redo']
    };

    const quickToolbarSettings = {
        image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
        link: ['Open', 'Edit', 'UnLink']
    };

    let rteObj;
    let rteObjForLessonDescritption;

    // set the value to Rich Text Editor
    // let template = `<div style="display:block;"><p style="margin-right:10px"></p></div>`;
    let template = "";
    let templateForLessonDescription = "";

    // Rich Text Editor items list
    let items = ['Bold', 'Italic', 'Underline', '|', 'Formats', 'Alignments', 'OrderedList',
        'UnorderedList', '|', 'CreateLink', 'Image', '|', 'SourceCode', '|', 'Undo', 'Redo'
    ];


    const htmlString = '<div class="e-rte-content" id="defaultRTErte-view" style="height: auto; margin-top: 0px; border-bottom: none;"><div class="e-content e-lib e-keyboard" id="defaultRTE_rte-edit-view" contenteditable="true" tabindex="0"><div style="display:block;"><p> </p><p style="margin-right: 10px; text-align: center;"><span style="font-size: 14pt;"><span style="font-family: &quot;Times New Roman&quot;, Times, serif;"><strong><span style="text-decoration: underline;"><span style="text-decoration: line-through;">dfkfdlfkdlkfdlfkdkfjdkf</span></span> fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</strong></span></span></p><p style="margin-right:10px"> </p><ul><li style="margin-right:10px"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,ewewew</span></li></ul><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv</span></div><ul><li style="display:block;"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c klklk</span><p style="margin-right: 10px; cursor: auto;"><img src="blob:http://localhost:3000/5a96c08a-fe90-4ee0-9d74-83bb7376a00e" class="e-rte-image e-imginline" alt="Screenshot (648).png" width="126" height="auto" style="min-width: 20px; min-height: 0px;">  </p><ul><li style="list-style-type: none;"><ul><li style="list-style-type: none;"><ul><li><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</span><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;"> </span></li></ul></li></ul></li></ul></li></ul></div></div>';

    const htmlContent = { __html: htmlString };

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle
                                className="h4"
                                style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "bold",
                                    color: "#333",
                                    textAlign: "center",
                                    marginBottom: "1rem",
                                    letterSpacing: "0.5px",
                                    textDecoration: "underline"
                                }}
                            >
                                {course?.title}
                            </CardTitle>



                            <div className="row">
                                <div className="col-md-12" >
                                    {/* <h1 className="text-center">All Modules</h1> */}

                                    <div className="mt-1" >
                                        <div className="row">
                                            <div className="col-3" >


                                                <div className="accordion" id="accordionExample" style={{ overflowY: "auto", height: "80vh" }}>
                                                    {modules?.map((d, i) => (
                                                        <div className="accordion-item" key={i}>

                                                            <h2 className="accordion-header" id={`heading${i}`}>
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#collapse${i}`}
                                                                    aria-expanded={i === 0 ? "true" : "false"}
                                                                    aria-controls={`collapse${i}`}>
                                                                    {d.title} ({d.type})

                                                                </button>
                                                            </h2>
                                                            <div
                                                                id={`collapse${i}`}
                                                                className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                                                                aria-labelledby={`heading${i}`}
                                                                data-bs-parent="#accordionExample">
                                                                <div className="accordion-body">

                                                                    {d?.lessons?.map((lessonData, i) => (
                                                                        <>
                                                                            <div className="" style={{ borderBottom: "1px solid gray", borderRadius: "1rem", padding: ".5rem", cursor: "pointer" }} onClick={() => handleGenerateLink(lessonData, i, d)}>
                                                                                {lessonData.contentType == "Video" && (

                                                                                    <i className="fa-solid fa-video" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "Pdf" && (

                                                                                    <i className="fa-solid fa-file-pdf" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "PPT" && (

                                                                                    <i className="fa-solid fa-file-powerpoint" style={{ fontSize: "1rem" }}></i>
                                                                                )}

                                                                                {`  `}{lessonData?.title} ({lessonData?.duration} min)

                                                                                {d?.progress?.lessonTrack[i] && (
                                                                                    <button
                                                                                        style={{
                                                                                            border: "none",
                                                                                            color: "green",
                                                                                            marginLeft: "1rem",
                                                                                            borderRadius: "0.2rem",
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa-solid fa-check"></i>
                                                                                    </button>
                                                                                )}

                                                                            </div >
                                                                        </>
                                                                    ))}
                                                                    {d?.assessment?.map((assessmentData, i) => (
                                                                        <>
                                                                            <h4 className="mt-2">Assesments</h4>
                                                                            <div
                                                                                className=""
                                                                                style={{
                                                                                    borderBottom: "1px solid gray",
                                                                                    borderRadius: "1rem",
                                                                                    padding: ".5rem",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                onClick={() => handleAssessmentClick(assessmentData)}
                                                                            >
                                                                                <i className="fa-solid fa-clipboard-check" style={{ fontSize: "1rem" }}></i>
                                                                                {`  `}{assessmentData?.title} ({assessmentData?.duration} min)


                                                                            </div>
                                                                        </>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-9" style={{ overflowY: "auto", height: "80vh" }}>

                                                {contentLink != null && !loader && contentType === "Video" && (
                                                    <div className="">
                                                        <video
                                                            src={contentLink} // Replace with your video file URL
                                                            alt="Video Preview"
                                                            controls // Keep this if you want the user to control playback
                                                            controlsList="nodownload"
                                                            onEnded={handleVideoEnd}
                                                            style={{
                                                                width: '100%',
                                                                height: 'auto',
                                                                marginBottom: '10px',
                                                            }}
                                                            onContextMenu={(e) => e.preventDefault()} // Disable right-click menu
                                                        />
                                                    </div>

                                                )}
                                                {contentLink != null && !loader && contentType === "Pdf" && (
                                                    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
                                                        {/* <iframe
                                                            src={contentLink + "#toolbar=0"}  // Disables PDF toolbar (no download, print options)
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',  // Ensure the iframe takes full height of the container
                                                                position: 'absolute',
                                                            }}
                                                            title="PDF Preview"
                                                        /> */}

                                                        {/* Transparent div overlay to prevent right-click and interactions */}
                                                        {/* <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                backgroundColor: 'transparent',
                                                                zIndex: 1,  // Ensure it sits above the iframe
                                                            }}
                                                            onContextMenu={(e) => e.preventDefault()}  // Disable right-click
                                                        /> */}

                                                        <PDFViewer preSignedUrl={contentLink} />
                                                    </div>
                                                )}
                                                {contentLink != null && !loader && contentType === "PPT" && (
                                                    <PPTViewer preSignedUrl={contentLink} />
                                                    // <div style={{ position: 'relative', width: '100%', height: '500px' }}>
                                                    //     <iframe
                                                    //         src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(contentLink)}`}
                                                    //         style={{
                                                    //             width: '100%',
                                                    //             height: '100%',  // Ensure the iframe takes full height of the container
                                                    //             position: 'absolute',
                                                    //         }}
                                                    //         frameBorder="0"
                                                    //         title="PPT Preview"
                                                    //     />

                                                    //     {/* Transparent div overlay to block full screen but allow interactions */}
                                                    //     <div
                                                    //         style={{
                                                    //             position: 'absolute',
                                                    //             top: 0,
                                                    //             left: 0,
                                                    //             width: '100%',
                                                    //             height: '100%',
                                                    //             backgroundColor: 'transparent',
                                                    //             zIndex: 1,  // Ensure it sits above the iframe
                                                    //             pointerEvents: 'none',  // Allow interaction with the iframe
                                                    //         }}
                                                    //         onContextMenu={(e) => e.preventDefault()}  // Disable right-click
                                                    //     />
                                                    // </div>
                                                )}

                                                {questions?.length > 0 && !loader && contentType == "assessment" && (
                                                    <div className="">
                                                        <Assessment questions={questions} />
                                                    </div>
                                                )}

                                                <div
                                                    className=""
                                                    dangerouslySetInnerHTML={{ __html: contentDescription }}
                                                ></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>


            {/* Modal for select Lesson or quiz  */}
            <Modal
                show={lessonOrQuizModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Select One
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>




                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Button type="button" color="info" onClick={() => { setAddLessonModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light " style={{ width: "10rem " }}>Create Lesson</Button>{" "}
                        <Button type="button" color="info" onClick={() => { setAddAssessmentModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light mt-2" style={{ width: "10rem " }}>Create Assessment</Button>{" "}
                    </div>



                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setLessonOrQuizModal(false)} className="waves-effect waves-light">Close</Button>{" "}

                </Modal.Footer>
            </Modal>
            {/* Modal for create Module  */}

            <Modal
                show={addModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddModule} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for Update Lesson  */}
            <Modal
                show={updateLessonModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Lesson
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={lessonTitle}
                                maxLength="50"
                                onChange={(e) => setLessonTitle(e.target.value)} />
                            {!setLessonTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Content Type
                        </label>
                        <div className="col-md-10">


                            <Select

                                value={lessonContentType}
                                onChange={handleLessonContentTypeChange}
                                options={lessonContentTypeData}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!lessonContentType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Lesson Duration in Minutes"
                                value={lessonDuration}
                                maxLength="50"
                                onChange={(e) => setLessonDuration(e.target.value)}
                            />
                            {!lessonDuration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select Content
                        </label>
                        <div className="col-md-10">


                            <input
                                type="file"
                                className='form-control'
                                placeholder="select the content"
                                accept="video/*,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                onChange={handleFileChange}
                            />
                            {!lessonContentFile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>






                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setUpdateLessonModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateLesson} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for update module  */}

            <Modal
                show={editModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateModule} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for delete confirm module  */}
            <Modal
                show={deleteModuleConfirmModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Module.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModuleConfirmModal(false); }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteModule} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for delete confirm Lesson  */}
            <Modal
                show={deleteLessonConfirmModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Lesson.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteLessonConfirmModal(false); }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteLesson} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for create student select  */}
            <Modal
                show={createStudentSelectModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <div className="d-flex justify-content-center">
                        <Button type="button" color="primary" onClick={() => { setCreateSingleStudentModal(true); setCreateStudentSelectModal(false) }} className="waves-effect waves-light align-self-end">Create Single Student</Button>
                        <Button type="button" color="info" onClick={() => setCreateBulkStudentModal(true)} className="ms-2 waves-effect waves-light align-self-end">Create Student in Bulk</Button>

                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setCreateStudentSelectModal(false); }} className="waves-effect waves-light">Close</Button>

                </Modal.Footer>
            </Modal>


            {/* Modal for create single student  */}
            <Modal
                show={createSingleStudentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            First Name
                        </label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter First Name"
                                value={studentDetails.firstname} // bind to studentDetails.firstname
                                maxLength="50"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    firstname: e.target.value // update the firstname field
                                }))}
                            />
                            {!studentDetails.firstname && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Last Name
                        </label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Last Name"
                                value={studentDetails.lastname}
                                maxLength="50"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    lastname: e.target.value
                                }))}
                            />
                            {!studentDetails.lastname && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Email
                        </label>
                        <div className="col-md-10">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Email"
                                value={studentDetails.email}
                                maxLength="100"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    email: e.target.value
                                }))}
                            />
                            {!studentDetails.email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Mobile
                        </label>
                        <div className="col-md-10">
                            <input
                                type="tel"
                                className="form-control"
                                placeholder="Enter Mobile Number"
                                value={studentDetails.mobile}
                                maxLength="15"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    mobile: e.target.value
                                }))}
                            />
                            {!studentDetails.mobile && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setCreateSingleStudentModal(false); }} className="waves-effect waves-light">Close</Button>
                    <Button type="button" color="success" onClick={() => console.log(studentDetails)} className="waves-effect waves-light">Create</Button>

                </Modal.Footer>
            </Modal>

            {/* Modal for assing a course access to the trainer  */}
            <Modal
                show={addTrainerAccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Trainer Access of this Course
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row className="mb-3">

                        <div className="d-flex flex-wrap">
                            <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                <label htmlFor="class_access" className="col-md-6 col-form-label">
                                    Create Test Assesment
                                </label>
                                <div className="mt-2">
                                    <input
                                        type="checkbox"
                                        id="class_access"
                                        name="class_access"
                                        value={1}
                                    />
                                </div>
                            </div>

                            <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                <label htmlFor="class_access" className="col-md-6 col-form-label">
                                    Add Student
                                </label>
                                <div className="mt-2">
                                    <input
                                        type="checkbox"
                                        id="class_access"
                                        name="class_access"
                                        value={1}
                                    />
                                </div>
                            </div>
                        </div>

                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setAddTrainerAccessModal(false); }} className="waves-effect waves-light">Close</Button>
                    <Button type="button" color="success" className="waves-effect waves-light">Save</Button>

                </Modal.Footer>
            </Modal>
        </React.Fragment >
    )
}

export default connect(null, { setBreadcrumbItems })(CourseView);